import { Component } from '@angular/core';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuditService } from 'src/app/services/audit.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ToastService } from 'src/app/toast/toast.service';

@Component({
  selector: 'app-view-society-detail',
  templateUrl: './view-society-detail.component.html',
  styleUrls: ['./view-society-detail.component.scss'],
})
export class ViewSocietyDetailComponent {
  isButtonDisabled: boolean = false;

  downloadUrl: string | null = null;
  roleid: number = 0;
  completed = false;
  isUpdateVisible: boolean = false;
  filteredData: any;
  transId: number = 0;
  iSocietyDetailsId: number = 0;
  remark: string = '';
  ddlStatus: string = '';
  // downloadDocument: string = '';
  lstAuditProcess: any[] = [];
  AuditStatus: any[] = [];
  fileName: string = '';
  fileExtension: string = '';
  selectedFile: File | null = null;
  base64String2: string = '';
  base64String: string = '';
  societyDetailData: any[] = [];
  basicCommonParameterData: any;
  commonAuditParametersData: any;
  pesticideDistributionData: any[] = [];
  lstEmployeesData: any[] = [];
  dataCooperative: any;
  lstBorrowerDetailsData: any[] = [];
  lstBalanceSheetData: any[] = [];
  lstBussinessUpgrade: any[] = []; // Assuming API data will be assigned here
  lstServiceData: any[] = []; // Filtered data to be used in table
  hidebutton: boolean = false;
  hideRemark: boolean = false;
  existingDeptRemark: boolean = false;
  hideARemarks: boolean = false;

  // auditStatus: any;
  rowsesLiabilities: any;
  rowsAssets: any;
  actionName: any;
  currentToggleId1: string = 'collapseOne';
  currentToggleId2: string = 'collapseTwo';
  currentToggleId3: string = 'collapseThree';
  currentToggleId4: string = 'collapseFour';
  currentToggleId5: string = 'collapseFive';
  currentToggleId6: string = 'collapseSix';
  currentToggleId7: string = 'collapseSeven';
  columns: any[] = [];
  iAllotAuditorID:any
  iSocietyDetailTranID:any
  isAuditChecked: boolean = false;
  col: any[] = [];
  columnss: any[] = [];
  column: any[] = [];
  newnonCredit = {
    iSocietyDetailsID: 1,
    iSocietyTransID: 1,
    sTrainingNo: '',
    sSpecificAuditYearArea: '',
    sNoTrainedConducted: '',
    sNoTeachingWorkers: '',
    sNoOtherStaff: '',
  };
  DepUpload = {
    DepartmentalRemarkDocument: '',
    sDepartmentalRemark: '',
    DepartmentalRemarkFileName: '',
    documentExtension: '',
    transid: 0,
  };
  ARnewUpload = {
    DepartmentalRemarkDocument: '',
    sDepartmentalRemark: '',
    DepartmentalRemarkFileName: '',
    documentExtension: '',
    transid: 0,
  };
  auditStatus: any = { sRemark: '' }; // Holds existing audit remarks
  arRemark: string = ''; // Holds AR remark
  cd: any;
  // remark = {
  //   Remarks: '',
  //   transId: 0
  // };

  constructor(
    private auditService: AuditService,
    private router: Router,
    private route: ActivatedRoute,
    private toastService: ToastService,
    private fb: FormBuilder,
    private authService: AuthService
  ) {
    this.route.params.subscribe((params) => {
      if (params['iSocietyDetailsId']) {
        this.iSocietyDetailsId = parseInt(params['iSocietyDetailsId']);
      }
    });
  }

  ngOnInit(): void {
    this.roleid = this.authService.currentUserValue.roleId;
    // this.updateStatusForm = this.fb.group({
    //   remarks: ['', Validators.required] // Validation: Required Field
    // });

    this.iSocietyDetailsId = Number(
      this.route.snapshot.paramMap.get('isocietydetailsid')
    );

    this.getSocietyDetail(this.iSocietyDetailsId);
    this.getSocietyAllDetail(this.iSocietyDetailsId);
    this.columns = [
      { prop: 'sSocietyEmpType', name: 'Employee Type' },
      { prop: 'noOfEmployees', name: 'No. of Employees' },
    ];
    this.col = [
      { prop: 'fieldName', name: 'Field Name' },
      { prop: 'value', name: 'Value' },
    ];
    this.columnss = [
      { prop: 'sCasteCategory', name: 'Caste Category' },
      { prop: 'sDefaulterName', name: 'Default No.' },
      { prop: 'sAmount', name: 'Amount' },
    ];
    this.column = [
      { prop: 'type', name: 'Type' },
      { prop: 'sParameterType', name: 'Type Value' },
      { prop: 'sAmount', name: 'Amount' },
    ];
  }

  updateArRemark(form: NgForm) {
  
    if (form.invalid) {
      this.toastService.showError('Please enter a remark.');
      return;
    }
    this.ARnewUpload.DepartmentalRemarkDocument = this.base64String || '';
    this.ARnewUpload.DepartmentalRemarkFileName = this.fileName;
    this.ARnewUpload.documentExtension = this.fileExtension;
    this.ARnewUpload.transid = this.transId;

    this.auditService.updateDepartmentalRemark(this.ARnewUpload).subscribe(
      (response) => {
        if (response.status === 200) {
          this.toastService.showSuccess(response.message);
          window.location.reload();
          this.isButtonDisabled = true;
          this.hideRemark = true;
          form.reset(); // Reset form after success
        } else {
          this.toastService.showError(response.message);
        }
      },
      (error) => {
        this.toastService.showError('Error updating remarks: ' + error.message);
      }
    );
  }
  getSocietyDetail(iSocietyDetailsId: number): void {
    this.auditService.getSocietyDetail(iSocietyDetailsId).subscribe(
      (response) => {
        if (
          response.status === 200 &&
          response.data &&
          response.data.length > 0
        ) {
          this.societyDetailData = response.data; // Assign the array
          this.transId = response.data[0].iSocietyTransID;
        } else {
          this.societyDetailData = []; // Set to empty array if no data is found
          this.toastService.showError(response.message || 'No data found');
        }
      },
      (error) => {
        this.societyDetailData = []; // Prevent undefined errors
        this.toastService.showError(
          'Error fetching society details: ' + error.message
        );
      }
    );
  }

  getSocietyAllDetail(iSocietyDetailsId: number): void {
    const actionName = 'InProcess';
    const auditorId = this.iAllotAuditorID;
    const transid = this.iSocietyDetailTranID;

    this.auditService.GetTransId(iSocietyDetailsId, actionName,auditorId,transid ).subscribe(
      (response) => {
        if (
          response.status === 200 &&
          response.data &&
          response.data.auditStatus.iARStatus == false
        ) {
          this.lstAuditProcess = response.data.lstAuditProcess || []; // Ensure it's an array
          this.pesticideDistributionData =
            response.data.lstBussinessUpgrade || [];
          this.basicCommonParameterData =
            response.data.dataBasicCommonParameter || [];
          this.commonAuditParametersData =
            response.data.dataCommonAuditParameters || [];

          this.auditStatus = response.data.auditStatus || [];

          this.hidebutton = true;
          this.hideRemark = false;

          if (
            this.roleid == 13 &&
            response.data.auditStatus.isCheckListCompleted &&
            response.data.auditStatus.moveForwaredByAuditor &&
            response.data.auditStatus.iDepartmentalRemark == false
          ) {
            // Hide both buttons initially
            this.hidebutton = true;
            this.hideRemark = true;
            // At the time of the Verifier Login
          }
         else if (
            this.roleid == 13 &&
            response.data.auditStatus.isCheckListCompleted &&
            response.data.auditStatus.moveForwaredByAuditor &&
            response.data.auditStatus.iDepartmentalRemark == true &&
            response.data.auditStatus.iARRemark == false
             && response.data.auditStatus.iARStatus == false

          ) {
            this.hidebutton = true;
            this.hideRemark = false;
          }
          else if (
            this.roleid == 13 &&
            response.data.auditStatus.iARRemark == true  && response.data.auditStatus.iARStatus == false
          ) {
            this.hidebutton = false;
            this.hideRemark = true;
          }
          else if(response.data.auditStatus.iDepartmentalRemark == false){
            this.hidebutton = true;
            this.hideRemark = false;
            this.existingDeptRemark = true;

          }
          else if(response.data.auditStatus.iDepartmentalRemark == true && response.data.auditStatus.iVerifierStatus == false){
            this.hidebutton = false;
            this.hideRemark = true;
            this.existingDeptRemark = true;
            

          }
          else if(response.data.auditStatus.iDepartmentalRemark == true && response.data.auditStatus.sDepartmentalDocument == null){
            this.hidebutton = false;
            this.hideRemark = true;
            this.existingDeptRemark = true;
            

          }
          else if(response.data.auditStatus.iDepartmentalRemark == true && response.data.auditStatus.sDepartmentalDocument != null){
            this.hidebutton = true;
            this.hideRemark = true;
            this.existingDeptRemark = true;
          

          }
          else if(response.data.auditStatus.sDepartmentalRemark == true && response.data.auditStatus.iVerifierStatus == true){
            this.hidebutton = true;
            this.hideRemark = true;
          

          }
          else if( this.roleid == 13 && response.data.auditStatus.iARRemark == true && response.data.auditStatus.iARStatus == true){
            this.hidebutton = true;
            this.hideRemark = true;
    

          }
          this.DepUpload = {
            transid: response.data.auditStatus?.transid || 0,
            DepartmentalRemarkDocument:
              response.data.auditStatus?.sDepartmentalDocument || '',
            sDepartmentalRemark:
              response.data.auditStatus?.sDepartmentalRemark || '',
            DepartmentalRemarkFileName:
              response.data.auditStatus?.DepartmentalRemarkFileName || '',
            documentExtension:
              response.data.auditStatus?.documentExtension || '',
          };
          this.lstEmployeesData = response.data.lstEmployees || [];
          this.dataCooperative = response.data.dataCooperative || [];
          this.lstBorrowerDetailsData = response.data.lstBorrowerDetails || [];
          this.lstBalanceSheetData = response.data.lstBalanceSheet || [];

          // Separate Liabilities and Assets
          this.rowsesLiabilities = this.lstBalanceSheetData.filter(
            (item: any) => item.type === 'Libalities'
          );

          this.rowsAssets = this.lstBalanceSheetData.filter(
            (item: any) => item.type === 'Assests'
          );

          this.lstBussinessUpgrade = response.data.lstBussinessUpgrade.filter(
            (business: any) => business.checked
          );
          this.lstServiceData = this.lstBussinessUpgrade
            .filter((business) => business.checked)
            .flatMap(
              (business) =>
                business.lstServiceData?.filter(
                  (service: any) => service.iBussinessSerID === business.id
                ) || []
            );
        }else{
          this.hidebutton = true;
          this.hideRemark = true;
        }
      },
      (error) => {
        this.toastService.showError(
          'Error fetching society details: ' + error.message
        );
      }
    );
  }

  onFileChange(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.fileName = file.name;
      this.fileExtension = this.getFileExtension(file.name);
      if (
        this.fileExtension !== 'jpg' &&
        this.fileExtension !== 'jpeg' &&
        this.fileExtension !== 'png' &&
        this.fileExtension !== 'pdf'
      ) {
        this.toastService.showError(
          'Invalid file type. Allowed types: jpg, jpeg, png, pdf.'
        );
        return;
      }
      const fileSizeInMB = file.size / (1024 * 1024); // Convert bytes to MB
      if (fileSizeInMB > 2) {
        this.toastService.showError(
          'File size should be less then or equal 2 MB'
        ); // Display error if file size exceeds 2MB
        return;
      }
      this.selectedFile = event.target.files[0];
      this.convertToBase64(file, 1);
      this.cd.detectChanges();
    }
  }
  convertToBase64(file: File, from: number): void {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (from === 1) {
        this.base64String = reader.result as string;
      }
      if (from === 2) {
        this.base64String2 = reader.result as string;
      }
    };
  }

  getFileExtension(fileName: string): string {
    const lastDotIndex = fileName.lastIndexOf('.'); // Find the last dot
    return lastDotIndex !== -1
      ? fileName.substring(lastDotIndex + 1).toLowerCase()
      : ''; // Get substring after the last dot
  }

  updateRemark(form: NgForm) {

    if (form.invalid) {
      this.toastService.showError('Please enter a remark.');
      return;
    }
    this.DepUpload.DepartmentalRemarkDocument = this.base64String || '';
    this.DepUpload.DepartmentalRemarkFileName = this.fileName;
    this.DepUpload.documentExtension = this.fileExtension;
    this.DepUpload.transid = this.transId;

    this.auditService.updateDepartmentalRemark(this.DepUpload).subscribe(
      (response) => {
        if (response.status === 200) {
          this.toastService.showSuccess(response.message);
          window.location.reload();
          this.isButtonDisabled = true;
          this.hideRemark = true;
          form.reset(); // Reset form after success
        } 
        
        
        else {
          this.toastService.showError(response.message);
        }
      },
      (error) => {
        this.toastService.showError('Error updating remarks: ' + error.message);
      }
    );
  }

  updateStatus(form: NgForm) {
    if (form.invalid) {
      this.toastService.showError('Please select status.');
      return;
    }
    const data = {
      transID: this.transId,
      iSocietyDetailID: this.iSocietyDetailsId,
      AuditStatus: this.ddlStatus,
    };

    this.auditService.updateDepartmentalStatus(data).subscribe(
      (response) => {
        this.toastService.showSuccess(response.message);
        form.reset(); // Reset form after success
        if (this.roleid === 13) {
          this.router.navigate(['/dashboard']);
        } else {
          this.router.navigate(['/audit/auditverification', 0]);
        }
      },
      (error) => {
        this.toastService.showError('Error updating remarks: ' + error.message);
      }
    );
  }

  closeCurrentToggle(currentToggleId: string) {
    const toggle = document.getElementById(currentToggleId) as HTMLElement;
    if (toggle && toggle.classList.contains('show')) {
      toggle.classList.remove('show');
    }
  }
  toggleNextCollapse(currentToggleId: string) {
    const totalToggles = 6;
    let nextToggleId: string | null = null;

    const allToggleIds = [
      'collapseOne',
      'collapseTwo',
      'collapseThree',
      'collapseFour',
      'collapseFive',
      'collapseSix',
      'collapseSeven',
    ];

    const currentIndex = allToggleIds.indexOf(currentToggleId);

    if (currentIndex !== -1 && currentIndex < allToggleIds.length - 1) {
      nextToggleId = allToggleIds[currentIndex + 1];
    }

    if (nextToggleId) {
      this.toggleCollapse(nextToggleId);
    } else {
    }
  }
  toggleCollapse(currentToggleId: string) {
    const toggle = document.getElementById(currentToggleId) as HTMLElement;
    if (toggle) {
      toggle.classList.toggle('show');
    }
  }

  saveCurrentToggle(currentToggleId: string) {
    localStorage.setItem(currentToggleId, 'completed');
  }

  PreviousButton(currentToggleId: string) {
    const previousToggleId = this.getPreviousToggleId(currentToggleId);
    if (previousToggleId) {
      this.toggleCollapse(previousToggleId);
    }
  }

  getPreviousToggleId(currentToggleId: string): string | null {
    const allToggleIds = [
      'collapseOne',
      'collapseTwo',
      'collapseThree',
      'collapseFour',
      'collapseFive',
      'collapseSix',
      'collapseSeven',
    ];

    const currentIndex = allToggleIds.indexOf(currentToggleId);
    if (currentIndex > 0) {
      return allToggleIds[currentIndex - 1];
    }
    return null;
  }

  openPreviousTogglesIfFilled(currentToggleId: string) {
    const allToggleIds = [
      'collapseOne',
      'collapseTwo',
      'collapseThree',
      'collapseFour',
      'collapseFive',
      'collapseSix',
      'collapseSeven',
    ];
    const currentIndex = allToggleIds.indexOf(currentToggleId);

    for (let i = 0; i < currentIndex; i++) {
      const toggleId = allToggleIds[i];
      const toggleStatus = localStorage.getItem(toggleId);

      if (toggleStatus === 'completed') {
        this.toggleCollapse(toggleId);
      }
    }
  }

  onRowActivate(event: any) {
  }

  toggleRowSelection(event: any, row: any) {
  }

  // downloadDocument() {

  //   if (this.auditStatus?.documentPath) {
  //     const fileUrl = this.auditStatus.documentPath;
  //     const link = document.createElement('a');
  //     link.href = fileUrl;
  //     link.target = '_blank'; // Open in a new tab
  //     link.download = fileUrl.split('/').pop() || 'downloaded-file'; // Extract filename from URL
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //   } else {
  //     this.toastService.showError('Document path is not available');
  //   }
  // }
  downloadDocument() {
    if (this.auditStatus?.documentPath) {
      const fileUrl = this.auditStatus.documentPath;
      const fileName = fileUrl.split('/').pop() || 'downloaded-image';

      // Create an anchor element
      const link = document.createElement('a');
      link.href = fileUrl;
      link.setAttribute('download', fileName); // Ensure download behavior
      link.style.display = 'none';

      // Append to the document and trigger download
      document.body.appendChild(link);
      link.click();

      // Clean up after download
      document.body.removeChild(link);
    } else {
      this.toastService.showError('Document path is not available');
    }
  }

  
}
